<template>
  <vs-table hover-flat v-if="callerIds && callerIds.length" :data="callerIds">
    <template slot="thead">
      <vs-th v-text="$t('no')"></vs-th>
      <vs-th v-text="$t('queue_status_call_id_sequence')"></vs-th>
      <vs-th v-text="$t('queue_status_service_name')"></vs-th>
      <vs-th v-text="$t('queue_status_caller_id')"></vs-th>
      <vs-th v-text="$t('total_users')"></vs-th>
      <vs-th class="text-center" v-text="$t('function')"></vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td v-text="tr.count" :data-tr-title="$t('no')"></vs-td>
        <vs-td v-text="tr.callIdSequence" :data-tr-title="$t('queue_status_call_id_sequence')"></vs-td>
        <vs-td v-text="tr.serviceName" :data-tr-title="$t('queue_status_service_name')"></vs-td>
        <vs-td v-text="tr.callerId" :data-tr-title="$t('queue_status_caller_id')"></vs-td>
        <vs-td v-text="tr.totalUsers" :data-tr-title="$t('total_users')"></vs-td>
        <vs-td>
          <div class="flex justify-center">
            <vs-button
              color="primary"
              type="border"
              icon-pack="feather"
              icon="icon-edit"
              size="small"
              @click="$emit('editCallerId', tr.id)"
            ></vs-button>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>

export default {
  name: 'Shared.CallerId.List',
  props: {
    callerIds: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style lang="scss">

</style>
